<script lang="ts">
    export let title: string;
    export let parent: string;
    export let home: string;
    import Link from "svelte-link/src/Link.svelte";
    import { Col } from "sveltestrap";
    import { href } from "../../utils/Constant/Constant";
</script>

<Col sm="6">
    <h3>{title}</h3>
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <Link href={href}>{home}</Link>
        </li>
        <li class="breadcrumb-item">{parent}</li>
        <li class="breadcrumb-item active">{title}</li>
    </ol>
</Col>
